/**
* @param {{ decoders: Record<string, (data: any) => any> }} value
*/
function set_app(value) {}
//#endregion
export { set_app as t };
